import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
  sessionsList: [],
  communicationChannelSessionsList: [],
  toolSets: [],
  systemPrompts: [],
  currentToolSet: {},
  currentSession: {},
  userSettings: {},
  editSession: {},
  editSystemPrompt: {},
  editToolSet: {},
  sendMessageData: undefined,
  chatWorkspace: {},
  userAICard: {},
  artifact: null,

  userAICardLoading: false,
  sessionsListLoading: false,
  communicationChannelSessionsListLoading: false,
  toolSetsLoading: false,
  userSettingsLoading: false,
  AIResponseLoading: false,
  currentSessionLoading: false,
  currentToolSetLoading: false,
  createToolSetLoading: false,
  systemPromptLoading: false,
  updateSystemPromptsLoading: false,
  sendMessageLoading: false,
  deleteSessionLoading: false,
  artifactLoading: false,
});

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};
